module.exports = __webpack_public_path__ + "img/logo-table.bfcd2776.png";